import * as React from "react";
import { Trans, useTranslation } from "react-i18next";
import styled from "styled-components";
import { DropdownButton, MenuItem } from "components/bootstrap";
import { DEFAULT_PAGE_SIZES } from "hooks/usePaginationQueryParameter";
const StyledDropdownButton = styled(DropdownButton)`
  ~ .dropdown-menu {
    min-width: auto;
  }
`;
const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 3px;
`;
const PageSizeSelect = ({
  pageSizes = DEFAULT_PAGE_SIZES,
  pageSize,
  onChange,
  className = "",
  showLabel = true
}) => {
  const { t } = useTranslation("common");
  const select = /* @__PURE__ */ React.createElement(
    StyledDropdownButton,
    {
      className,
      id: "page-size-select",
      title: t("page_size.rows", { count: pageSize }),
      "aria-label": t("page_size.configure"),
      pullRight: true,
      bsSize: "small",
      bsStyle: "default"
    },
    pageSizes.map((size) => /* @__PURE__ */ React.createElement(MenuItem, { key: `option-${size}`, onSelect: () => onChange(size) }, size))
  );
  if (showLabel) {
    return /* @__PURE__ */ React.createElement(Container, { className }, /* @__PURE__ */ React.createElement(Trans, { t, i18nKey: "page_size.show", components: { select } }));
  }
  return select;
};
export default PageSizeSelect;
